var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareVariationOne = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24 9.333 14.667 0v5.333C5.333 6.667 1.333 13.333 0 20c3.333-4.667 8-6.8 14.667-6.8v5.467z"
})));
export { SvgShareVariationOne as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDkuMzMzMzNMMTQuNjY2NyAwVjUuMzMzMzNDNS4zMzMzMyA2LjY2NjY3IDEuMzMzMzMgMTMuMzMzMyAwIDIwQzMuMzMzMzMgMTUuMzMzMyA4IDEzLjIgMTQuNjY2NyAxMy4yVjE4LjY2NjdMMjQgOS4zMzMzM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";